/*
 * @Author: limengxue888 106235002+limengxue888@users.noreply.github.com
 * @Date: 2024-09-04 16:33:03
 * @LastEditors: limengxue888 106235002+limengxue888@users.noreply.github.com
 * @LastEditTime: 2024-09-04 16:33:13
 * @FilePath: \crm-new-fontend\weixin\client\src\store\vuexPlugin.js
 * @Description: 
 */

// vuexPlugin.js
export default function (store) {
  // 为了简洁起见，我们只打印状态树的根级别
  console.log('Initial state:', store.state);
 
  store.subscribe((mutation, state) => {
    // 每次 mutation 之后调用
    console.log(`[mutation] type: ${mutation.type}`, mutation.payload);
  });
 
  store.subscribeAction((action, state) => {
    // 每次 action 调用之后调用
    console.log(`[action] type: ${action.type}`, action.payload);
  });
}